export default __webpack_public_path__ + "static/media/Trio-Soprano-Ave-Maria-Master-1.93876e1f.wav";